jQuery(document).ready(function () {
	jQuery('.testimonial-block').matchHeight({
		property: 'min-height'
	});
	jQuery('.ld-course-list-items .ld_course_grid .thumbnail.course').matchHeight({
		property: 'min-height'
	});
	//cookie notice
	const cookieButton = document.querySelector('.accept-cookies-btn');
	if (cookieButton) {
		cookieButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			document.querySelector('#cn-accept-cookie').click();
			document.location.href = '/';
		});
	}
	const cookieButtonRefuse = document.querySelector('.dont-accept-cookies-btn');
	if (cookieButtonRefuse) {
		cookieButtonRefuse.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			document.querySelector('#cn-refuse-cookie').click();
			document.cookie.split(";").forEach(function(c) {
				document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;domain=."+window.location.host);
			});
			document.location.href = '/';
		});
	}
	//newsletter form
	const nlForm = document.getElementById('newsletter-form-box');
	if (nlForm) {
		const validateEmail = (mail) => { return mail.search(/^[\w\d\._\-]+@[\w\d\-_\.]+\.[\d\w][\d\w]+$/) > -1; };
		const checkIfValid = () => {
			if (validateEmail(emailInput.value.trim()) && checkInput.checked) {
				button.classList.remove('is-disabled');
			} else {
				button.classList.add('is-disabled');
			}
		};
		const sendNlAjax = () => {
			if (validateEmail(emailInput.value.trim()) && checkInput.checked) {
				const xhr = new XMLHttpRequest();
				const nonce = nlForm.querySelector('#nonce-form').value.trim();
				xhr.open('POST', `${localData.siteURL}`);
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
				xhr.onload = function () {
					const response = JSON.parse(this.responseText);
					if (xhr.status === 200 && response.data.status === 200) {
						window.location.href = response.data.url;
					} else {
						nlForm.querySelector('.news-form__container').innerHTML += '<p>Napaka pri pošiljanju, prosim poskusite kasneje.</p>';
					}
				};
				xhr.send(`action=sendToNl&email=${emailInput.value.trim()}&nonce=${nonce}&checked=${checkInput.checked}&ID=${localData.id}`);
			}
		};
		const button = nlForm.querySelector('#btn-submit-div');
		const emailInput = nlForm.querySelector('#email');
		const checkInput = nlForm.querySelector('#checkbox-email');
		emailInput.addEventListener('keyup', () => {
			checkIfValid();
		});
		checkInput.addEventListener('click', () => {
			checkIfValid();
		});
		button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			sendNlAjax();
		});
	}
	//login form - plugin wppb
	const loginForm = document.getElementById('login-link-button');
	if (loginForm) {
		loginForm.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			const modalLogin = document.querySelector('.learndash-wrapper-login-modal');
			modalLogin.classList.add('ld-modal-open');
			modalLogin.classList.remove('ld-modal-closed');
			window.scrollTo({top: 0, behavior: 'smooth'});
		});
	}
});
